import joi from 'joi';
import { dateSchema } from '../../utils/joi/schemas';

export enum ExpirationPeriodUnits {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum ExpirationType {
  ROLLING = 'ROLLING',
  CALENDAR = 'CALENDAR',
  NONE = 'NONE',
  END_OF_MONTH = 'END_OF_MONTH',
  END_OF_WEEK = 'END_OF_WEEK',
}

export enum ExpirationMode {
  RESET = 'RESET',
  REEVALUATE = 'REEVALUATE',
}

export interface ExpirationPeriod {
  value: number;
  unit: ExpirationPeriodUnits;
}

export type ExpirationAttributes =
  | RollingExpirationAttributes
  | CalendarExpirationAttributes
  | NoneExpirationAttributes
  | EndOfMonthExpirationAttributes
  | EndOfWeekExpirationAttributes;
export interface NoneExpirationAttributes {
  type: ExpirationType.NONE;
  expirationMode?: ExpirationMode;
}

export interface RollingExpirationAttributes {
  type: ExpirationType.ROLLING;
  period: ExpirationPeriod;
  expirationMode?: ExpirationMode;
}

export interface CalendarExpirationAttributes {
  type: ExpirationType.CALENDAR;
  date: string;
  period: ExpirationPeriod;
  expirationMode?: ExpirationMode;
}

export interface EndOfMonthExpirationAttributes {
  type: ExpirationType.END_OF_MONTH;
  expirationMode?: ExpirationMode;
}

export interface EndOfWeekExpirationAttributes {
  type: ExpirationType.END_OF_WEEK;
  expirationMode?: ExpirationMode;
}
export const $expirationAttributes = joi
  .object<ExpirationAttributes>()
  .keys({
    type: joi.string().valid(...Object.values(ExpirationType)),
  })
  .when('.type', {
    is: ExpirationType.ROLLING,
    then: joi.object<RollingExpirationAttributes>({
      period: joi.object({
        value: joi.number().min(1).max(999),
        unit: joi.string().valid(...Object.values(ExpirationPeriodUnits)),
      }),
    }),
  })
  .when('.type', {
    is: ExpirationType.CALENDAR,
    then: joi.object<CalendarExpirationAttributes>({
      date: dateSchema,
      period: joi.object({
        value: joi.number().min(1).max(999),
        unit: joi.string().valid(...Object.values(ExpirationPeriodUnits)),
      }),
    }),
  });
